/**
 * Class representation of `calls.powerlist`.
 */

import { ISchedulableHours } from "../interfaces/ISchedulableHours";
export class PowerlistDispositionRule {
  powerlistDispositionRuleId?: number | null = null;
  powerlistId?: number;
  businessDispositionId?: number;
  action?: "remove" | "forwardToCadence" | "sendSMS";
  smsTemplateId?: number;
  forwardToCadenceId?: number;
  constructor(init?: Partial<PowerlistDispositionRule>) {
    Object.assign(this, init);
  }
}

export class PowerlistSpreadsheet {
  powerlistSpreadsheetId?: number | null = null;
  powerlistId?: number;
  status?: string;
  duplicateHandling?: boolean;
  awsS3Key?: string;
  uploadedByUserId?: string;
  uploadDate?: string;
}

export class PowerlistUserSubscription {
  powerlistTeamId?: number;
  userId?: number;
  isSubscribed?: boolean;
}

export class PowerlistTeam {
  powerlistTeamId?: number | null = null;
  teamId?: number;
  teamname?: number;
  memberCount?: number;
  lastUpdated?: Date;
  constructor(init?: Partial<PowerlistTeam>) {
    Object.assign(this, init);
  }
}

export interface IPowerlistHeaderMapping {
  [header: string]: string;
}

export class Powerlist {
  powerlistId?: number | null = null;
  businessId?: string;
  status?: "active" | "inactive" | "deleted";
  name!: string;
  assignToAgentOnAnswer!: boolean;
  overrideOwnerOnAnswer!: boolean;
  onlyDialFromOwnerIfOwned!: boolean;
  mustDespositionCalls!: boolean;
  ignoreDNC!: boolean;
  autostartOnLogon!: boolean;
  secondsBeforeTimeout?: number;
  maxAttempts?: number;
  dialAtATime?: number;
  maxAttemptsPerDay?: number;
  nextPowerlistId?: number | null;
  minDurationBeforeCallRetryInMin?: number;
  minDurationDays?: number;
  minDurationHours?: number;
  minDurationMinutes?: number;
  maxWaitAfterCallInSec?: number;
  maxSmsPerTemplateCount?: number;
  maxSmsPerTemplateDurationInMin?: number;
  maxSmsPerTemplateDurationInDaySub?: number;
  powerlistPriority?: number;
  maxSmsPerTemplateDurationInHourSub?: number;
  maxSmsPerTemplateDurationInMinSub?: number;
  createdByUserId?: number;
  powerlistHours!: ISchedulableHours;
  targetHours!: ISchedulableHours;
  updatedDate?: Date;
  createdDate?: Date;
  useBusinessHoursForPowerlist?: boolean;
  useBusinessHoursForTarget?: boolean;
  powerlistDispositionRulesDeleted?: PowerlistDispositionRule[];
  powerlistDispositionRules?: PowerlistDispositionRule[];
  powerlistTeamsDeleted?: PowerlistTeam[];
  powerlistTeams?: PowerlistTeam[];
  powerlistSpreadsheets?: PowerlistSpreadsheet[];
  duplicateHandling?: string;
  isAgentPowerlist?: number;
  headerMapping?: IPowerlistHeaderMapping;
  useDefaultDispositionRules?: Boolean;
  constructor(init?: Partial<Powerlist>) {
    Object.assign(this, init);
  }
}
